export default __webpack_public_path__ + "static/Kimberly_Chang_Resume-8ee9e6c9bcff54966ba7bec1ca2179ba.pdf";